if (!customElements.get('expandable-description')) {
  const blockedElements = ['script', 'meta', 'style'];

  class ExpandableDescription extends HTMLElement {
    constructor() {
      super();
    }

    /*
    getFirstChild(element) {
      if (
        !blockedElements.includes(
          element.firstChild.nodeName.toLowerCase()
        )
      )
        return element.firstChild;

      for (const node of element.childNodes) {
        if (
          !blockedElements.includes(
            element.firstChild.nodeName.toLowerCase()
          )
        )
          continue;
        return node;
      }
    }
    */

    connectedCallback() {
      this.description = this.querySelector(
        '.js-expandable-description'
      );
      this.button = this.querySelector('.js-description-button');

      if (!this.description || !this.button || this.description.childNodes <= 1) return;

      /*
      if (this.description.firstChild.nodeName == '#text') {
        const wrapper = document.createElement('span');
        wrapper.innerText = this.description.firstChild.textContent;
        this.description.replaceChild(
          wrapper,
          this.description.firstChild
        );
      }

      this.child = this.getFirstChild(this.description);
      */

      this.child = this.querySelector('span[data-show]');
      if (!this.child) return;

      this.description.style.setProperty(
        '--height-opened',
        this.description.scrollHeight + 'px'
      );

      this.description.style.setProperty(
        '--height-closed',
        (this.child.offsetTop + 20) + 'px'
      );

      this.child.style.fontSize = '0px';

      this.button.classList.remove('hidden');

      this.button.addEventListener('click', (event) => {
        event.preventDefault();

        this.description.classList.toggle('is-open');
      });
    }
  }
  customElements.define(
    'expandable-description',
    ExpandableDescription
  );
}
